import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useCallback } from 'react'; // @ts-ignore: Could not find a declaration file for module 'bowlingx-react-slick': Upgrade package

import SliderImport from 'bowlingx-react-slick';
import { applyStylingHoc } from '../../lib/styling.js';
import baseStyles from './Carousel.scss';
var Slider = SliderImport.default || SliderImport;
var defaultSettings = {
  dots: true,
  lazyLoad: true,
  arrows: true,
  infinite: false,
  animating: true,
  swipe: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  variableWidth: false,
  responsive: [{
    breakpoint: 500,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 900,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 1300,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 9999,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4
    }
  }]
};
var singleSlideSettings = {
  dots: false,
  arrows: false
};
var EMPTY_OBJECT = {
  onInit: null
};
export var Carousel = function Carousel(props) {
  var styles = props.styles,
      children = props.children,
      propSettings = props.settings;

  var _ref = propSettings || EMPTY_OBJECT,
      customOnInit = _ref.onInit;

  var thisSettings = children && children.size === 1 ? singleSlideSettings : EMPTY_OBJECT;
  var onInit = useCallback(function () {
    if (customOnInit) {
      customOnInit(children);
    }
  }, [customOnInit, children]);

  var settings = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultSettings), propSettings), thisSettings), {}, {
    onInit: onInit
  });

  return React.createElement("div", {
    className: styles.root
  }, React.createElement(Slider, _objectSpread({
    className: styles.slider
  }, settings), children));
};
export default applyStylingHoc(baseStyles)(memo(Carousel));